var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"router-view",attrs:{"id":"app"}},[_c('keep-alive',{attrs:{"include":['QuickLogin','Packages']}},[_c('router-view',{attrs:{"loginStatus":_vm.loginStatus}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }